import type { OrchestratedQueryStore } from "@/domains/library"
import type { ManualClPoolApiData } from "@/domains/thick-v1/types"
import type { TokenRepository } from "@/domains/tokens"
import { IEventBus } from "@/domains/events"
import { OrchestratedQuery } from "@/domains/library"

import { ManualClGraphQlTransport } from "./manual-cl-graphql-transport"
import { ManualClOrchestrator } from "./manual-cl-orchestrator"
import { ManualClPoolRepository } from "./manual-cl-repository"

export class ManualClOrchestratorFactory {
  /**
   * Create a fully configured ManualClOrchestrator with its OrchestratedQueries.
   *
   * The pools sync query starts as part of `initialize()` — manual CL is now
   * a first-class product surface rather than a feature-flagged experiment,
   * so there's no gate between construction and data fetching.
   */
  static create(
    manualClGraphQlTransport: ManualClGraphQlTransport,
    manualClPoolRepository: ManualClPoolRepository,
    tokenRepository: TokenRepository,
    orchestratedQueryStore: OrchestratedQueryStore,
    eventBus: IEventBus,
  ): ManualClOrchestrator {
    const orchestrator = new ManualClOrchestrator(
      manualClPoolRepository,
      manualClGraphQlTransport,
      tokenRepository,
      eventBus,
    )

    const loadPoolsQuery = new OrchestratedQuery<Array<ManualClPoolApiData>>(
      "Manual CL Pools Sync",
      (query) => orchestrator.onLoadPoolsTrigger(query),
      60_000,
      orchestrator.onLoadPoolsQuerySuccess.bind(orchestrator),
      orchestrator.onLoadPoolsQueryFailed.bind(orchestrator),
      orchestratedQueryStore,
    )

    orchestrator.initialize(loadPoolsQuery)

    return orchestrator
  }
}
